// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/diversion-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/diversion-procedures/diversion-procedures.js';

mount([g0]);
